export default __webpack_public_path__ + "static/media/Japsbag1.3cadd1c9.jpg";